export default "__VITE_ASSET__DGEzy6i0__"